import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Language } from './../models/language';
import { apis, controllerTypes, HttpRequestSettings } from './../models/request-settings';
import { HttpWebApiService } from './http-web-api.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageCodeService {

  config: HttpRequestSettings = {
    api: apis.Web
  };

  coreConfig: HttpRequestSettings = {
    api: apis.Core,
    controllerType: controllerTypes.User
  };
  cachedLanguages$: Observable<Language[]>;

  constructor(private http: HttpWebApiService) { }

  getLanguageCodesForOrganisation(organisationId?: number, isAnonymous: boolean = false): Observable<Language[]> {
    if (this.cachedLanguages$) return this.cachedLanguages$;
    const urlRoleBase = 'OrganisationLanguage/';
    const urlRoleBasePublic = 'WebLanguageCodePublic/';

    let langServiceCall: Observable<Language[]>;

    if (window.EveryBuddy.DisplayInUserLanguage && !isAnonymous)
    {
      langServiceCall = this.http.get(urlRoleBase + 'GetLanguageCodesForOrganisation', {
        ...this.coreConfig,
        orgId: organisationId
      });
    }
    else
    //use the public service if we are not logged-in
    {
      langServiceCall = this.http.get(urlRoleBasePublic + 'GetLanguageCodesForOrganisation?organisationId=' + organisationId, {
        ...this.config
      });
    }

    this.cachedLanguages$ = langServiceCall
    // Add flag icon urls
    .pipe(
      map(languages => languages.map((language: Language) => {
        const countryCode = language.countryCode;
        return {
          ...language,
          languageTag: `${language.languageCode}-${countryCode}`,
          imgUrl: `${environment.cdnBase}flags/${(countryCode === 'hant' ? 'CN' : countryCode).toUpperCase()}.png`
        }
      })),
      shareReplay(1)
    );
    return this.cachedLanguages$;
  }
}
